//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQAvatar from "@/components/Generics/AQAvatar/AQAvatar.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";

export default {
    components: {
        AQAvatar,
        AQButton
    },
    beforeRouteEnter(to, from, next) {
        next(vueInstance => {
            const vm = vueInstance;
            if (to.query && to.query.email) {
                vm.username = to.query.email;
                vm.accDisabled = to.query.status === "DIS";
            }
        });
    },
    data() {
        return {
            username: "",
            accDisabled: false
        };
    },
    computed: {
        title() {
            return this.accDisabled ? this.$t("login.accountDisabled") : this.$t("login.accountNotRegistered");
        },
        msgBody() {
            return this.accDisabled ? this.$t("login.accountDisabledBodyMsg") : this.$t("login.accountNotRegisteredBodyMsg");
        }
    },
    methods: {
        redirectToLogin() {
            this.$store.commit("main/setFromAccountDisabled", true);
            this.$router.push({ name: "login", params: { username: this.username, initialState: true } });
        }
    }
};
